<template>
    <div class="header">
        <div class="navigator">
            <div class="logo-n-site-name">
                <img alt="Vue logo" src="../assets/logo.png" class="logo">
                <h1 class="site-name">
                    Backend SaaS
                </h1>
            </div>
            <nav class="router-menu">
                <router-link class="router-link" to="/">Create API</router-link>
                <router-link class="router-link" to="/projects">My Projects</router-link>
            </nav>
            <div class="sign-btn">
                Sign in / Sign up
            </div>
        </div>
    </div>
</template>

<script lang="ts">
// import { Options, Vue } from 'vue-class-component';
import { Vue } from 'vue-class-component';

// @Options({
//   props: {
//     msg: String
//   }
// })
export default class Header extends Vue {
    // msg!: string
}
</script>

<style scoped lang="stylus">
.header
    background-color white
    height 72px
    border-bottom 3px solid #e5e7eb
    display flex
    justify-content center

.navigator
    display flex
    min-width 1200px
    gap 32px
    align-items center
    justify-content space-between

.logo
    height 40px
    display flex

.site-name
    font-weight bold
    font-size 24px

.logo-n-site-name
    display flex
    align-items center
    gap 12px

.router-menu
    display flex
    gap 32px

.router-link
    color black
    font-size 18px
    font-weight bold
    text-decoration none
    margin-top 27px
    height 45px
    padding-left 6px
    padding-right 6px

.router-link-active
    border-bottom 4px solid #4f46e5

.sign-btn
    margin-left: auto;
    border 4px solid #4f46e5
    padding 12px
    font-weight bold
    border-radius: 12px;

</style>
